import { IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';

// MSAL requires a non-empty clientId even to construct the instance. While SSO is disabled
// (environment.sso.enabled === false) we hand it a placeholder GUID so bootstrap never throws;
// none of the MSAL flows run in that state because the guard/interceptor/login check the flag.
const PLACEHOLDER_CLIENT_ID = '00000000-0000-0000-0000-000000000000';

function resolveClientId(): string {
    return environment.sso.enabled && environment.sso.clientId
        ? environment.sso.clientId
        : PLACEHOLDER_CLIENT_ID;
}

export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication({
        auth: {
            clientId: resolveClientId(),
            authority: `https://login.microsoftonline.com/${environment.sso.tenantId}`,
            redirectUri: environment.sso.redirectUri,
            // After sign-out, come back to the app (its root routes to /login) instead of
            // stranding the user on Microsoft's "You signed out of your account" page. Reuses
            // the registered SPA redirect URI so no app-registration change is needed.
            postLogoutRedirectUri: environment.sso.redirectUri
        },
        cache: {
            cacheLocation: 'localStorage'
        }
    });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: environment.sso.apiScope ? [environment.sso.apiScope] : []
        }
    };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    if (environment.sso.apiScope) {
        protectedResourceMap.set(environment.adminApiUrl, [environment.sso.apiScope]);
    }
    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap
    };
}
